import AppConfig, { WindowInletConfig } from '../types/app-config'

declare const WEBPACK_INLET_CONFIG: AppConfig
declare const WEBPACK_INLET_PORTAL_CONFIG_KEY: string

export function getConfig<TConfig extends AppConfig = AppConfig>() {
  const mapWindowConfig = (windowInletsConfig: WindowInletConfig): AppConfig => {
    const { webApi, portals, ...restConfig } = windowInletsConfig
    const key = portals[WEBPACK_INLET_PORTAL_CONFIG_KEY]?.webApiKey
    if (!key) {
      throw new Error(`Missing api key portal ${WEBPACK_INLET_PORTAL_CONFIG_KEY} configuration`)
    }
    return {
      ...restConfig,
      webApi: {
        url: webApi.url,
        key
      }
    }
  }

  return (WEBPACK_INLET_CONFIG ?? mapWindowConfig(window.inletsConfig as WindowInletConfig)) as unknown as TConfig
}
